export const RESET_PRODUCTS = 'RESET_PRODUCTS'
export const RESET_PRODUCT_BILLING_FREQUENCIES = 'RESET_PRODUCT_BILLING_FREQUENCIES'
export const RESET_PRODUCT_BUNDLE_TYPES = 'RESET_PRODUCT_BUNDLE_TYPES'
export const RESET_PRODUCT_CATEGORIES = 'RESET_PRODUCT_CATEGORIES'
export const RESET_PRODUCT_INVENTORY_TYPES = 'RESET_PRODUCT_INVENTORY_TYPES'
export const RESET_PRODUCT_STATUSES = 'RESET_PRODUCT_STATUSES'
export const RESET_PRODUCT_TYPES = 'RESET_PRODUCT_TYPES'
export const RESET_PRODUCT_FAMILIES = 'RESET_PRODUCT_FAMILIES'
export const RESET_PRODUCT_METRICS = 'RESET_PRODUCT_METRICS'
export const SET_PRODUCT_BILLING_FREQUENCIES = 'SET_PRODUCT_BILLING_FREQUENCIES'
export const SET_PRODUCT_BUNDLE_TYPES = 'SET_PRODUCT_BUNDLE_TYPES'
export const SET_PRODUCT_CATEGORIES = 'SET_PRODUCT_CATEGORIES'
export const SET_PRODUCT_INVENTORY_TYPES = 'SET_PRODUCT_INVENTORY_TYPES'
export const SET_PRODUCT_STATUSES = 'SET_PRODUCT_STATUSES'
export const SET_PRODUCT_TYPES = 'SET_PRODUCT_TYPES'
export const SET_PRODUCT_FAMILIES = 'SET_PRODUCT_FAMILIES'
export const SET_PRODUCT_METRICS = 'SET_PRODUCT_METRICS'
export const SET_PRODUCTS = 'SET_PRODUCTS'
